import { Match } from "../hooks/useFindReplace";

// Escapes HTML special characters to prevent injection
function escapeHTML(str: string) {
  return str.replace(
    /[&<>"']/g,
    (m) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[m]!)
  );
}

function mergeRanges(ranges: { start: number; end: number; matchIndex: number }[]) {
  if (!ranges.length) return [];
  // Sort by start
  ranges = ranges.slice().sort((a, b) => a.start - b.start);
  const merged = [ranges[0]];
  for (let i = 1; i < ranges.length; i++) {
    const prev = merged[merged.length - 1];
    const curr = ranges[i];
    if (curr.start <= prev.end) {
      // Overlap: merge and keep the lower matchIndex for color
      prev.end = Math.max(prev.end, curr.end);
      prev.matchIndex = Math.min(prev.matchIndex, curr.matchIndex);
    } else {
      merged.push(curr);
    }
  }
  return merged;
}

export const getHighlightedText = (text: string, textIndex: number, matches: Match[], currentIndex: number) => {
  let result = "";
  let lastIndex = 0;
  // Filter matches for this textIndex and sort by start
  const filtered = matches
    .map((m, i) => ({ ...m, matchIndex: i }))
    .filter(({ textIndex: idx }) => idx === textIndex)
    .sort((a, b) => a.start - b.start);

  // Merge overlapping/adjacent ranges
  const merged = mergeRanges(filtered);

  for (const { start, end, matchIndex } of merged) {
    // Add non-highlighted text before the match
    if (start > lastIndex) {
      result += escapeHTML(text.slice(lastIndex, start));
    }
    // Only highlight the exact match, not trailing spaces/newlines
    let matchStr = text.slice(start, end);
    let trailing = "";
    const match = matchStr.match(/^(.*?)([\s\n]+)$/);
    if (match) {
      matchStr = match[1];
      trailing = match[2];
    }
    const color = matchIndex === currentIndex ? "orange" : "yellow";
    result += `<span style="background:${color};color:black">${escapeHTML(matchStr)}</span>${escapeHTML(trailing)}`;
    lastIndex = end;
  }
  // Add any remaining text
  if (lastIndex < text.length) {
    result += escapeHTML(text.slice(lastIndex));
  }
  return result;
};
